import store from "@/store";

const routes = [
    {
        path: "/system-settings/navigation-drawer/:id",
        name: "navigationdrawer",
        component: () => import('@/views/main/SystemSettings/NavigationDrawer.vue'),
        beforeEnter:(to,from,next)=>{
            store.dispatch('checkAccessUser', to.params.id).then((response)=>{
                if(response == 'fail'){
                    next('/no-access')
                    }else{
                    next()
                }
            }).catch(()=>{

            })
        },
        meta:{
            requiresAuth:true,
            title:'Navigation Settings'
        }
    },
    {
        path: "/system-settings/general-settings/:id",
        name: "generalsettings",
        component: () => import('@/views/main/SystemSettings/GeneralSettingsComponent.vue'),
        beforeEnter:(to,from,next)=>{
            store.dispatch('checkAccessUser', to.params.id).then((response)=>{
                if(response == 'fail'){
                    next('/no-access')
                    }else{
                    next()
                }
            }).catch(()=>{

            })
        },
        meta:{
            requiresAuth:true,
            title:'General Settings'
        }
    },
]
export default routes;
